import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { type PropType } from 'vue';

import { modalType, modalVariant, type ModalVariant, type ModalType } from './modal-type-validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalContent',
  props: {
  type: { type: String as PropType<ModalType>, default: modalType.base },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "content",
    class: _normalizeClass(['modal-content', `modal-content--${__props.type}`, `modal-content--${__props.variant}`])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})